import React from "react";

import Base from "./utils/Base";
import BaseContext from "./utils/BaseContext";

const Index = () => {
  const { pages, styleguidePath } = React.useContext(BaseContext);

  return (
    <>
      {styleguidePath && (
        <p>
          <a href={styleguidePath}>Styleguide</a>
        </p>
      )}
      {pages && (
        <>
          <p key="pages-title">Pages:</p>
          <ul>
            {pages.map((page) => (
              <li key={page}>
                <a href={page}>{page.replace(".html", "")}</a>
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );
};

export default () => {
  // Using hook in top level page component don't work and ends up in Error: Invalid hook call.
  // Calling hooks in inner component works like <Base /> or <Index /> works
  // Dunno why :'(

  return (
    <Base>
      <Index />
    </Base>
  );
};
